import { useTranslation } from 'react-i18next'

const Classmate1End = (props) => {
  const { t } = useTranslation()

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="classmate1-end-title"
      fill="none"
      {...props}
    >
      <title id="classmate1-end-title">{t('antagonists:classmate1:components:end')}</title>
      <defs>
        <clipPath id="classmate1-b">
          <path
            d="M1714.3 843.89c-19.83 1.31-22.54 18.19-28.48 23.34-5.93 5.14-7.12 13.84-7.12 13.84s7.52 16.61 7.52 29.26 10.67 37.18 10.67 37.18 24.51-1.98 44.3-2.77c19.78-.8 36-3.95 36-3.95s6.72-7.92-1.18-22.54c-7.92-14.64-13.05-13.05-20.96-29.26-7.92-16.22-10.67-26.5-10.67-26.5s-5.93-20.17-30.06-18.59h-.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-c">
          <path
            d="M1593.9 238.2c-21.44-1.26-54.86.64-65.58 22.7-10.72 22.08-10.08 35.93-10.08 35.93s-23.96 6.93-27.75 26.49c-3.79 19.54.64 18.92 5.67 44.14 5.05 25.21 23.4 65.48 39.17 92.59 15.77 27.11 18.99 62.82 18.99 62.82s79.48-6.64 115.42-71.6c35.93-64.94 17.47-75.63 25.04-98.34 7.57-22.7 1.9-47.93-7.57-57.37-9.46-9.46-15.13-9.46-15.13-9.46s-3.15-25.21-19.54-27.75c-16.39-2.52-58.63-20.18-58.63-20.18v.03Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-d">
          <path
            d="M1617.78 161.57s-13.33 33.08-24.59 44.73c-11.25 11.66-30.38 21.58-30.38 21.58l19.21-32.56s-16.31 3.71-25.14 15.21c-9.91 12.92-11.02 32.61-2.58 47.07s16.88 31.35 35.36 30.95c18.48-.4 24.9-7.06 36.56-15.5 11.66-8.44 14.08-11.82 16.49-23.08 2.41-11.25 1.66-23.37 1.66-23.37l-19.99 23.21s5.54-29.85 1.29-47.72c-1.98-8.3-7.87-40.54-7.87-40.54l-.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-e">
          <path
            d="M1525.17 841.38c19.85-1.1 24.58 15.34 31.08 19.74 6.51 4.4 8.73 12.89 8.73 12.89s-5.46 17.39-3.93 29.96c1.53 12.57-6.12 38.2-6.12 38.2s-24.58.99-44.31 2.58c-19.72 1.59-36.21.41-36.21.41s-7.63-7.04-1.53-22.52c6.08-15.48 11.39-14.53 17.28-31.59 5.89-17.04 7.41-27.59 7.41-27.59s3.46-20.74 27.6-22.08Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#f8f7f0}.h{fill:#f08d64}.i{fill:#eb6a36}.j{fill:#feca1b}.k{fill:#6b5738}.l{fill:#8cabbc}.m{fill:#dfbe84}.n{fill:#dda141}.o{fill:#afb1b4}.p{fill:#e2a972}.q{fill:#a93985}.r{fill:#235a96}.s{fill:#1a4431}.t{fill:#497125}.u{fill:#4f4e47}.v{clip-path:url(#classmate1-c)}.w{clip-path:url(#classmate1-b)}.x{clip-path:url(#classmate1-e)}.y{clip-path:url(#classmate1-d)}'
          }
        </style>
      </defs>
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1409.93 526.04 4.22 139.33 22.27 4.67-6.26-145.64-20.23 1.64z"
      />
      <path
        transform="rotate(-.37 1820.574 639.233)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1810.63 635.44h18.75v6.61h-18.75z"
      />
      <path
        transform="rotate(-.37 1827.897 769.335)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1818.73 765.79h18.75v6.61h-18.75z"
      />
      <path
        transform="rotate(-3.95 1830.998 909.322)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1821.68 906.05h18.75v6.61h-18.75z"
      />
      <path
        transform="rotate(-1.13 1389.737 632.844)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1380.49 629.35h18.75v6.61h-18.75z"
      />
      <path
        transform="rotate(-1.13 1385.41 763.12)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1375.81 759.89h18.75v6.61h-18.75z"
      />
      <path
        transform="rotate(-87.54 1385.95 903.925)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1382.64 894.55h6.61v18.75h-6.61z"
      />
      <path
        d="M1380.22 584.49c-6.83-.19-7.65 3.38-7.87 12.38-.22 9-3.06 337.2-3.5 342.6-.45 5.4-.54 12.49 6.66 12.49s7.53-8.27 7.3-13.44c-.22-5.18 3.73-336.25 3.73-340.76s1.8-13.05-6.31-13.28v.02ZM1834.05 585.62c6.83-.38 7.74 3.15 8.24 12.15.49 9 12.71 336.98 13.32 342.36s.91 12.46-6.29 12.66c-7.2.21-7.76-8.04-7.68-13.22s-13.35-336.01-13.49-340.5c-.13-4.49-2.17-13 5.93-13.46h-.02Z"
        style={{
          fill: '#f8f7f0',
        }}
      />
      <path
        d="m1820.23 608.23-.76 24.26s5.88 19.13 6.99 27.22c.89 6.53 1.83 17.65 1.83 17.65s8.39-.88 9.56-5.51c1.16-4.65 4.05-16.79 4.05-16.79l4.05 27.44s12.07-5.37 13.24-8.46c1.16-3.09-.25-11.25 1.67-12.03 1.93-.78 11.99-8.52 13.94-12.77 1.93-4.25-6.96-28.64-12.77-37.93-5.8-9.29-6.58-26.31-6.58-26.31l-35.22 4.65v18.57h.02Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1798.64 428.42c-24.8 15.16-29.12 32.62-23.51 55.35 5.61 22.73 41.91 119.26 41.91 119.26l39.96-6.71 4.49-18s20.01-9.17 15.69-47.08c-4.27-37.53-59.49-114.46-78.56-102.82h.02Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1454.26 659.33s71.26 50.52 148.88 47.8c77.62-2.72 143.05-47.8 143.05-47.8l-34.1-313.1-230.13 7.18s-22.24 304.55-27.68 305.92h-.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1549.84 315.98s-91.94 18.84-118.86 49.66c-31.52 36.11-73.78 43.72-94.04 88.88-18.73 41.73 59.89 50.68 59.89 50.68s43.12-19.1 50.68-23.03c23.03-11.98 59.68-14.97 73.21-50.46 13.51-35.49 50.8-104.39 29.13-115.74h-.02ZM1687.61 336.02s31.75-19.51 59.83 10.27c25.44 26.98 95.52 113.79 105.18 127.84 9.53 13.87-62.22 48.88-62.22 48.88s-37.83-37.67-44.2-43.34c-17.71-15.75-53.82-18.06-67.33-53.57-13.51-35.49-12.9-78.77 8.76-90.11l-.02.02Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1553.52 307.81s-27.91 12.73-48.55 20.8c-27.35 10.7-32.7 17.43-32.7 17.43s-10.32 121.58-13.32 176.77c-2.28 42.16 57.95 80.22 57.95 80.22l198.67-6.45c.54 0 43.53-18.88 29.52-94.5-19.96-107.71 1.07-149.06-5.53-161.47-11.93-22.44-186.04-32.83-186.04-32.83v.03Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1438.14 671.14 353.91 180.89-5.61-24.65-353.31-182.27 5.01 26.03z"
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1437.37 824.33 343.37-172.71 1.77 20.97-335.98 169.28-9.16-17.54z"
      />
      <path
        style={{
          fill: 'none',
        }}
        d="m1785.42 657.25 26.25 2.1 5.26 226.83-28.35 3.16-3.16-232.09zM1441.13 668.65l-24.11-12.73-5.26 226.84 28.35 3.14 1.02-217.25z"
      />
      <path
        d="M1440.4 659.06c-10.51 0-8.24 22.47-8.98 33.7s2.1 244.93 2.1 244.93l21.15 1s-4.52-228.7-3.78-242.94c.75-14.24 2.25-36.7-10.48-36.7h-.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1808.22 563.87c9.11-.25 11.5 6.56 12.26 19.96.76 13.33 13.11 359.71 13.41 370.19.3 10.48-.75 21.95-12.62 22.3-11.88.33-12.92-11.69-12.89-22.2.05-11.68-11.5-356.59-12.03-367.79-.54-11.87-1.47-22.08 11.87-22.44l-.02-.02Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1793.56 911.96c21.55.27 21.77 34.64 22.3 53.06.53 18.41 5.29 47.67-18.62 47.56-18.17-.08-21.65-16.63-22.79-42.85-1.15-26.23-9.51-58.12 19.11-57.77Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1778.1 661.58c10.5-.56 9.41 22.01 10.75 33.19s7.31 244.95 7.31 244.95l-20.15 4.03s-4.95-230.79-6.45-244.96c-1.5-14.18-4.17-36.54 8.55-37.21h-.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="m1804.58 921 1.13 34.44-159.52 6.94.43-26.63 132.46-6.48s.72-9.7 6.56-12.87c14.59-7.9 18.92 4.62 18.92 4.62l.02-.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1601.72 568.16c-44.07 1.37-85.98-29.39-104.35-32.33s-44.09.73-57.33 11.76c-13.22 11.02-5.14 98.47 10.29 149.19 15.43 50.7 29.39 96.27 27.92 116.85-1.47 20.58 13.95 66.34 13.95 66.34s11.77-8.28 36.03.54c24.24 8.82 30.49 4.11 28.29 4.11s13.25-17.31 14.72-36.41c1.47-19.11 8.43-33.1-2.6-61.02-11.02-27.92-33.07-124.19-33.07-124.19s41.89 8.08 67.6 5.14c25.72-2.95 78.64-14.7 78.64-14.7s-12.49 116.85-4.41 137.41c8.08 20.58 10.29 33.8 3.68 42.62-6.61 8.82 4.06 55.8 4.06 55.8s15.77-11.71 41.49-10.23c25.72 1.47 19.72-13.79 19.72-13.79s15.12 8.84 22.47-27.89c7.34-36.75-4.71-116.31-1.04-158.93 3.68-42.62 17.63-72.01 5.14-112.44-12.49-40.41-42.62-40.41-63.94-33.8s-83.77 35.28-107.29 36.01v-.03Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1692.94 800.38s-.4 26.89-2.77 36.78-2.77 34.41-2.77 34.41l58.93 16.22s.4-19.78-1.18-32.03c-1.58-12.26-2.77-26.5-1.98-34.41.8-7.92 4.75-25.31 4.75-25.31l-54.97 4.35h-.02Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1714.3 843.89c-19.83 1.31-22.54 18.19-28.48 23.34-5.93 5.14-7.12 13.84-7.12 13.84s7.52 16.61 7.52 29.26 10.67 37.18 10.67 37.18 24.51-1.98 44.3-2.77c19.78-.8 36-3.95 36-3.95s6.72-7.92-1.18-22.54c-7.92-14.64-13.05-13.05-20.96-29.26-7.92-16.22-10.67-26.5-10.67-26.5s-5.93-20.17-30.06-18.59h-.02Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-b)',
        }}
      >
        <path
          d="M1674.75 902.03c.4 1.18 8.3 19.38 21.76 23.34 13.44 3.95 43.1-1.98 57.34-1.98s24.13-5.54 24.13-5.54l8.3 42.72-121.42-5.54 9.89-52.99Z"
          style={{
            fill: '#dda141',
          }}
        />
      </g>
      <path
        d="M1593.9 238.2c-21.44-1.26-54.86.64-65.58 22.7-10.72 22.08-10.08 35.93-10.08 35.93s-23.96 6.93-27.75 26.49c-3.79 19.54.64 18.92 5.67 44.14 5.05 25.21 23.4 65.48 39.17 92.59 15.77 27.11 18.99 62.82 18.99 62.82s79.48-6.64 115.42-71.6c35.93-64.94 17.47-75.63 25.04-98.34 7.57-22.7 1.9-47.93-7.57-57.37-9.46-9.46-15.13-9.46-15.13-9.46s-3.15-25.21-19.54-27.75c-16.39-2.52-58.63-20.18-58.63-20.18v.03Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-c)',
        }}
      >
        <path
          d="M1510.04 267.84s37.21 104.67 57.37 117.28c20.18 12.62 49.81 0 78.19-31.52 28.37-31.52 34.05-90.17 34.05-90.17l-151.34-79.45-18.29 83.86Z"
          style={{
            fill: '#f08d64',
          }}
        />
      </g>
      <path
        d="M1620.25 133.68c-5.48-2.1-33.66-26.22-66.56-7.66-32.91 18.56-38.91 84.02-38.91 84.02l14.08-15.05s-6.88 13.75-8.82 23.18c-3.31 16.01 1.66 34.76 1.66 34.76l8.28-21.52s-2.04 25.04 9.92 37.51c9.33 9.73 22.01 14.11 32.56 20.96l34.13 2.72s36.76-11.39 47.67-30.38c9.78-17.04 12.84-44.17 12.84-44.17l6.01 16.71s3.74-36.46-2.28-55.89c-8.24-26.52-21.28-45.78-31.6-46.43-11.12-.7-18.95 1.23-18.95 1.23l-.02.02Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1617.78 161.57s-13.33 33.08-24.59 44.73c-11.25 11.66-30.38 21.58-30.38 21.58l19.21-32.56s-16.31 3.71-25.14 15.21c-9.91 12.92-11.02 32.61-2.58 47.07s16.88 31.35 35.36 30.95c18.48-.4 24.9-7.06 36.56-15.5 11.66-8.44 14.08-11.82 16.49-23.08 2.41-11.25 1.66-23.37 1.66-23.37l-19.99 23.21s5.54-29.85 1.29-47.72c-1.98-8.3-7.87-40.54-7.87-40.54l-.02.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-d)',
        }}
      >
        <path
          d="M1607.12 187.12s5.13-1.69 13.25-.62c5.05.67 15.16 10.67 15.16 10.67l-1.43 1.9s-5.94-6.42-13.33-7.28-13.28 1.35-13.28 1.35l-.37-6.02Z"
          style={{
            fill: '#6b5738',
          }}
        />
      </g>
      <path
        d="M1557.5 247.57s6.32 29.12 7.12 36.75c.8 7.63 6.44 27.44 27.73 27.84 21.3.4 27.92-18.01 33.96-25.25 6.02-7.23 10.75-28.89 10.75-28.89l-79.56-10.45Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1580.84 255.36c.46 5.18 8.94 8.44 14.38 8.06s13.91-7.85 14.38-10.35c.46-2.5-3.27-6.39-7.45-6.58s-6.53 2.12-6.53 2.12-2.99-1.5-7.82.43c-4.81 1.93-7.23 3.19-6.96 6.32Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <path
        d="M1614.7 205.49c2.72.94 4.01 3.44 2.99 6.08s-3.14 3.12-5.64 2.44c-2.95-.81-4-3.14-3.22-5.94.54-1.99 3.06-3.54 5.86-2.56v-.02Z"
        style={{
          fill: '#235a96',
        }}
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1618.13 207.65-16.55-.33.79-5.48 15.66-1.58.1 7.39z"
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1794.71 530.87 4.83 136.3-21.43 1.37-2.99-135.63 19.59-2.04z"
      />
      <path
        d="m1799.84 518.32 1.16 17.06-32.45 2.21s-.88-12.9-.78-17.51 7.28-9.7 16.04-9.88 15.59 1.86 16.02 8.11ZM1829.56 692.54c-3.33-7.73-14.49-7.02-20.93-1.8-6.44 5.22-30.47 27.59-30.47 27.59l1.5 5 20.87-10.83s11.63-1.23 20.6-3.22c7.17-1.59 11.77-9.02 8.44-16.74ZM1405.04 511.07v17.09h32.53s0-12.93-.41-17.52-7.92-9.17-16.68-8.76-15.43 2.91-15.43 9.17v.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1405.18 563.22c-9.06 1-12.82 7.36-12.98 20.09-.18 13.35-1.24 358.93-1.24 369.41s1.37 21.92 13.25 21.92 12.58-12.06 12.23-22.55c-.38-11.66 2.17-356.86 1.47-368.04-.7-11.18-.16-22.22-12.74-20.82h.02Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1430.04 909.54c-21.54.89-20.77 35.27-20.77 53.68s-3.92 47.8 19.97 47.02c18.16-.59 21.15-17.23 21.55-43.48s7.84-58.38-20.77-57.2l.02-.02Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1425.6 926.18v34.47l158.84.24-1.31-26.62-131.79-.67s-1.04-9.68-6.98-12.65c-14.83-7.42-18.76 5.24-18.76 5.24v-.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1541.13 795.62s3.63 26.65 7.18 36.17c3.55 9.53 6.9 33.83 6.9 33.83l-56.55 23.19s-2.77-19.58-2.68-31.95c.1-12.36-.45-26.63-2.18-34.39-1.74-7.76-7.76-24.56-7.76-24.56l55.1-2.31-.02.02Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1525.17 841.38c19.85-1.1 24.58 15.34 31.08 19.74 6.51 4.4 8.73 12.89 8.73 12.89s-5.46 17.39-3.93 29.96c1.53 12.57-6.12 38.2-6.12 38.2s-24.58.99-44.31 2.58c-19.72 1.59-36.21.41-36.21.41s-7.63-7.04-1.53-22.52c6.08-15.48 11.39-14.53 17.28-31.59 5.89-17.04 7.41-27.59 7.41-27.59s3.46-20.74 27.6-22.08Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-e)',
        }}
      >
        <path
          d="M1571.44 894.34c-.25 1.23-5.91 20.25-18.78 25.79-12.87 5.54-43.04 3.23-57.17 4.94-14.13 1.72-24.61-2.6-24.61-2.6l-3.11 43.4 119.86-20.12-16.2-51.42Z"
          style={{
            fill: '#dda141',
          }}
        />
      </g>
      <path
        d="m1440.67 713.35-19.59-13.6s-6.87-6.01-14.49-9.27c-7.63-3.27-18.56-.89-19.64 7.45-1.08 8.35 5.38 14.22 12.71 13.79 9.17-.54 20.69-2.55 20.69-2.55l18.84 9.3 1.47-5.14.02.02Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1332.99 519.75c-32.43-34.8 19.4-89.12 19.4-89.12s84.95 35.65 93.12 38.74c21.9 8.25 38.83 18.95 38.83 18.95l-8.71 44.38-14.75 7.12s-12.92 26.49-48.04 17.04c-36.48-9.81-69.97-26.52-79.85-37.13v.02Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1470.39 506.44c5.67.03 65.94 11.98 68.91 12.69 2.96.72 38.05 20.13 38.05 20.13s-1.94 5.35-5.3 6.04c-3.36.67-11.6-2.1-11.6-2.1l10.5 8.16s-3.42 5.64-9.25 3.65c-5.83-1.99-19.67-12.34-21.87-13.01s-3.31-.88-3.31-.88l20.4 21.57s-5.99 4.52-9.21 2.85-18.41-16.5-19.77-17.43c-4.01-2.76-9.24-1.32-10.11-.81-.88.49 4.14 1.72 7.73 4.97 3.58 3.23 13.35 13.81 13.35 13.81s-3.38 5.35-8.79 3.36c-3.25-1.19-10.45-9.46-12.47-10.77-2.02-1.31-19.35-8.09-22.78-8.68s-24.85.7-37.77-7.28c-5.16-3.19-10.32-10.99-11.91-11.72-2.09-.96 6.28-24.64 25.21-24.53v-.02Z"
        style={{
          fill: '#e2a972',
        }}
      />
    </svg>
  )
}

export default Classmate1End